import Layer from "ol/layer/Layer";
import { Source } from "ol/source";
import { StyleName } from '../../local_modules/voyage-style/src/voyage-style';

export interface WeatherLayerStatus
{
    visible: boolean;
    opacity?: number;
}

export enum LayerGroup
{
    Wind,
    SeaAndSwell,
    PressureAndTemp,
    Others
}


export interface WeatherLayerInfo
{
    element: string;
    name: string;
    group: LayerGroup;
    area?: WeatherLayerStatus;
    grid?: WeatherLayerStatus;
    line?: WeatherLayerStatus;
    nongrid?: WeatherLayerStatus;
}

export interface ChartDepths
{
    safetyContour: number;
    shallowContour: number;
    deepContour: number;
    safetyDepth: number;
}

export abstract class MgLayersBase extends EventTarget
{
    abstract get layers(): Layer<Source>[];
    abstract get list(): WeatherLayerInfo[];
    abstract get chartDepths(): ChartDepths;
    abstract get borderLayersEnabled(): boolean;
    abstract setVisible(element: string, type: string, visible: boolean): void;
    abstract setOpacity(element: string, type: string, opacity: number): void;
    abstract toggleBorderLayers(visible: boolean): void;
    abstract setChartDepths(depths: ChartDepths): void;
    abstract zoomLevelChanged(zoom: number): void;
    abstract initialize(mapConfig: any): Promise<void>;
}

export abstract class ChartLayersBase
{
    abstract get layers(): Layer<Source>[];
    abstract setChartDepths(depths: ChartDepths): void;
    abstract setColorScheme(colorScheme: StyleName): void;
    abstract zoomLevelChanged(zoom: number): void;
    abstract initialize(mapConfig: any): Promise<void>;
}



let MgLayers: MgLayersBase|null = null;

function setMgLayers(model: MgLayersBase)
{
    MgLayers = model;
}

export { MgLayers, setMgLayers };
